import React from "react";
import { useParams } from "react-router-dom";
import MtvContainer from "./MtvContainer/MtvContainer";

const SessionContainer = ({mtvSetup, ...rest}) => {
  let { id } = useParams();
  if(!id)
  return <>Session Id must exist</>
  const settings ={...mtvSetup,play_sid:id } 
  return (
    <>
        <div className="hide">Session ({id})</div>
      <MtvContainer mtvSetup={settings}  />
    </>
  );
};

export default SessionContainer;
